/**
 * Role Selector enum
 */
export enum Selector {
  BANNER = 0,
  MODAL = 1,
}
